"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    ApplicationSettingsClient: Symbol("ApplicationSettingsClient"),
    ApplicationSettingsRoute: Symbol("ApplicationSettingsRoute"),
    SettingsClient: Symbol("SettingsClient"),
    SettingsRoute: Symbol("SettingsRoute"),
    VersionClient: Symbol("VersionClient"),
    VersionRoute: Symbol("VersionRoute"),
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.ApplicationSettingsRoute).to(_1.ApplicationSettingsRoute);
    bind(TYPES.ApplicationSettingsClient).to(_1.ApplicationSettingsClient);
    bind(TYPES.SettingsClient).to(_1.SettingsClient);
    bind(TYPES.SettingsRoute).to(_1.SettingsRoute);
    bind(TYPES.VersionClient).to(_1.VersionClient);
    bind(TYPES.VersionRoute).to(_1.VersionRoute);
});
exports.diModule = diModule;
